import React from 'react';
import { ResidentPaymentStatus } from '../../types/Payments';
import { formatPaymentStatusLabel, PAYMENT_STATUS_COLORS, PAYMENT_STATUS_HINTS, PaymentOrderLike, resolveOrderPaymentStatus } from '../../utils/paymentStatus';
import './style.less';

type PaymentStatusBadgeProps = {
    status?: ResidentPaymentStatus;
    order?: PaymentOrderLike;
    className?: string;
    facilityPaymentsEnabled?: boolean;
};

const PaymentStatusBadge: React.FC<PaymentStatusBadgeProps> = ({ status, order, className = '', facilityPaymentsEnabled = false }) => {
    const resolvedStatus = status || resolveOrderPaymentStatus(order, facilityPaymentsEnabled);
    const label = formatPaymentStatusLabel(resolvedStatus);
    const color = PAYMENT_STATUS_COLORS[resolvedStatus];

    return (
        <span
            className={`neighbors-payment-status-badge ${className}`.trim()}
            title={PAYMENT_STATUS_HINTS[resolvedStatus]}
            style={{
                borderColor: color,
                color,
            }}
        >
            {label}
        </span>
    );
};

export default PaymentStatusBadge;
